import { ICasMRTCellProps } from './ICasMRTCellProps';

export default function CasMRTCellRenderArrayAsCSV({ cell }: ICasMRTCellProps) {
  const value = cell.getValue();
  return value?.map((item: string) => item).join(', ');
}
